/**
 * External dependencies
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import './styles.scss';

class Items extends Component {
    static propTypes = {
        className: PropTypes.string,
    };

    render() {
        return (
            <ul className={classNames('topbar__items', this.props.className)} data-tip-target='items'>
                {this.props.children}
            </ul>
        );
    }
}
export default Items;
